import RowItemLetterTable from './RowItemLetterTable.jsx';

export {
  RowItemLetterTable
}


// WEBPACK FOOTER //
// ./src/components/modules/home/dataTable/index.js